/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class l{constructor(){this.committedVertices=null,this.cursorVertex=null,this.full=null,this.outline=null,this.cursorEdge=null,this.circle=null,this.rectangle=null}}export{l as CreateOperationGeometry};
